<div class="general-container">
  <fun-spinner *ngIf="loading"></fun-spinner>
  <fun-overal-message *ngIf="!loading" [text]="text" [btnList]="btnList" (btnEvent)="deleteAccount($event)" [image]="image"></fun-overal-message>
</div>